// src/pages/SliderDemo.jsx
import React from 'react';
import styled from 'styled-components';
import HeroSlider from '../components/HeroSlider';

const Container = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 30px;
  color: var(--fg);
`;

const testSlides = [
  {
    id: 1,
    title: "Элитная недвижимость в центре Москвы",
    benefits: "Премиальные квартиры с панорамными видами и современными планировками",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop",
    slug: "elite-apartment-center"
  },
  {
    id: 2,
    title: "Инвестиционные объекты в Дубае",
    benefits: "Высокая доходность и стабильный рост стоимости недвижимости",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&h=600&fit=crop",
    slug: "penthouse-sea-view"
  },
  {
    id: 3,
    title: "Загородные резиденции премиум-класса",
    benefits: "Эксклюзивные особняки в престижных поселках Подмосковья",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&h=600&fit=crop",
    slug: "luxury-mansion"
  }
];

export default function SliderDemo() {
  return (
    <Container>
      <Title>Демонстрация главного слайдера</Title>
      <HeroSlider 
        items={testSlides} 
        autoplay 
        autoplayIntervalMs={4000} 
        pauseOnHover={true} 
      />
    </Container>
  );
}